define('vspot-angular/services/tracking-service',[], function () {
    'use strict';

    /*
     *  Functions to handle tracking.
     */
    return ['services.User', '$timeout', '$log', function (User, $timeout, $log) {
        /*
         *  Hash function to turn email into an integer.
         */
        var getUserIdentifier = function (email) {
            var i, chr, len;
            var hash = 0;

            if (!email) {
                return hash;
            } else if (email.length === 0) {
                return hash;
            }

            for (i = 0, len = email.length; i < len; i++) {
                chr   = email.charCodeAt(i);
                hash  = ((hash << 5) - hash) + chr;
                hash |= 0; // Convert to 32bit integer
            }

            return hash;
        };

        /*
         *  Based on the given page or piece we're testing,
         *  return all the possible test variations for it.
         *
         *  @param testingPage [STRING] [REQUIRED] The piece we want variations for.
         *
         *  @returns An array of variations for the given piece.
         */
        var getBranches = function (testingPage) {
            // null means the step does not apply for that case
            Vspot.data.tracking = {
                branches: {
                    // No active experiments at the moment
                }
            };

            return Vspot.data.tracking.branches[testingPage];
        };

        return {
            /*
             *  Record a user interaction in google analytics.
             *
             *  @param category [STRING] [REQUIRED]
             *  The name you supply for the group of objects you want to track.
             *
             *  @param action [STRING] [REQUIRED]
             *  A string that is uniquely paired with each category, and commonly used to define the type of user interaction for the web object.
             *
             *  @param label [STRING] [OPTIONAL]
             *  An optional string to provide additional dimensions to the event data.
             *
             *  @param value [INT] [OPTIONAL]
             *  An integer that you can use to provide numerical data about the user event.
             *
             *  @param nonInteraction [BOOLEAN] [OPTIONAL]
             *  A boolean that when set to true, indicates that the event hit will not be used in bounce-rate calculation.
             */
            trackEvent: function (category, action, label, value, nonInteraction) {
                if (gtag === undefined) {
                    return false;
                } else {
                    try {
    //                    _gaq.push(['_setAccount', 'UA-3705553-1'],['_trackEvent', category, action, label, value, nonInteraction]);
    //                     ga('send', 'event', category, action, label, value, nonInteraction);
                        // GA4
                        gtag('event', action, {
                            'event_category': category,
                            'event_label': label,
                            'value': value,
                            'non_interaction': nonInteraction
                        });

                    } catch (e) {}
                }
            },

            /*
             * Record a page view in google analytics. These are synthetic page view,
             * such as in a modal.
             *
             * @param url (str) REQUIRED - the string to log for the synthetic page view.
             * @param callback (function) REQUIRED - a callback to call when done. Will
             * return true for false to indicate if the page view worked.
             *
             * NOTE: all callbacks are called in a $timeout to force a digest loop in
             * Angular. This is important for getting the UI to update when things change.
             * Also the callbacks keep the user on the page so that it does not change before the
             * analytics call completes or the call can get aborted and the pageview is missed
             */
            trackPageview: function(url, callback) {
                if( callback === undefined ) {
                    $log.error("services.Tracking::trackPageview - callback not defined.");
                    return false;
                } else if( url === undefined ) {
                    $log.error("services.Tracking::trackPageview - url not defined.");
                    callback(false);
                } else if ( gtag === undefined ) {
                    $log.error("services.Tracking::trackPageview - ga not defined.");
                    callback(false);
                } else {
                    // We have the required params, and ga exists
                    
                    var t = $timeout(function() {
                        $log.log("services.Tracking::trackPageview - calling callback from the timeout, so perhaps GA did not return successfully.");
                        callback(false);
                    }, 2000);

                    try {
                        ga('send', {
                          'hitType':    'pageview',
                          'page':        url,
                          // 'hitCallback': function() {
                          //   // Cancel the timeout because ga completed...
                          //   $timeout.cancel(t);
                          //   $timeout(function() {
                          //       callback(true);
                          //   });
                          // }
                        });
                        // GA4
                        gtag('event', 'page_view', {
                            page_location: url,
                            'event_callback': function(containerId) {
                                // Cancel the timeout because ga completed...
                                $timeout.cancel(t);
                                $timeout(function() {
                                    // Google tag manager can fire this multiple times for different containers
                                    // We have one for GTM, and another for analytics. Ignore the GTM one
                                    $log.log("gtag callback container: " + containerId + "for url: " + url);
                                    if (typeof containerId === 'string' && !containerId.startsWith("GTM-") && typeof callback === "function") {
                                        callback(true);
                                    }
                                });
                            }
                        });
                    } catch (e) {
                        $log.error("services.Tracking::trackPageview - ga returned an error:", e);
                        $timeout.cancel(t);
                        $timeout(function() {
                            callback(false);
                        });
                    }
                }
            },

            /*
             * Record an event for Google Tag Manager
             *
             * @param event (str) REQUIRED - the string to log for the GTM event.
             * @param callback (function) REQUIRED - a callback to call when done. Will
             * return true for false to indicate if the event tracking worked.
             *
             * NOTE: all callbacks are called in a $timeout to force a digest loop in
             * Angular. This is important for getting the UI to update when things change.
             */
            gtmTrackEvent: function(event, callback) {
                window.dataLayer = window.dataLayer || [];

                if( callback === undefined ) {
                    $log.error("services.Tracking::gtmTrackEvent - callback not defined.");
                    return false;
                } else if( event === undefined ) {
                    $log.error("services.Tracking::gtmTrackEvent - event not defined.");
                    callback(false);
                } else {
                    // We have the required params

                    var t = $timeout(function() {
                        $log.log("services.Tracking::gtmTrackEvent - calling callback from the timeout, so perhaps GTM did not return successfully.");
                        callback(false);
                    }, 2000);

                    try {
                        window.dataLayer.push({
                            'event':        event,
                            'eventCallback':  function(containerId) {
                                // Cancel the timeout because ga completed...
                                $timeout.cancel(t);
                                $timeout(function() {
                                    $log.log("gtm callback container: " + containerId + "for event: " + event);
                                    callback(true);
                                });
                            }
                        });
                    } catch(e) {
                        $log.error("services.Tracking::gtmTrack - datalayer.push returned an error:", e);
                        $timeout.cancel(t);
                        $timeout(function() {
                            callback(false);
                        });
                    }
                }
            },

            /*
             *  Same as trackEvent, except only track events that occur while in the activity
             *  create wizard.
             */
            trackWizardEvent: function (category, action, label, value, nonInteraction) {
                var url = window.location.href;
              
                if ((url.indexOf('edit') === -1) && ((url.indexOf('create') !== -1) || (url.indexOf('jobs') !== -1) || (url.indexOf('themes') !== -1) || (url.indexOf('finish') !== -1))) {
                    this.trackEvent(category, action, label, value, nonInteraction);
                }
            },

            /*
             *  Get the variation of experiment for the current user.
             *
             *  @param email [STRING] [OPTIONAL]
             *  The user's email. A hash is made to determine what variation to show.
             *
             *  @param numVariations [INT] [OPTIONAL]
             *  How many variations are in the experiment. Two by default.
             */
            getUserExperimentVariation: function (email, numVariations) {
                var user = User.get();
                // use logged in user by default
                if (!email) {
                    if (user) {
                        email = user.email;
                    } else {
                        // no email found; use the default
                        return 0;
                    }
                }
                // we do a/b tests by default, but allow for more
                if (!numVariations) {
                    numVariations = 2;
                }

                return Math.abs(getUserIdentifier(email) % numVariations);
            },

            /*
             *  Return content experiment information based on the given
             *  page and user.
             *
             *  @param page  [STRING] [REQUIRED] The page we're experimenting on.
             *  @param email [STRING] [OPTIONAL] The user we want to run the experiment on.
             *                                   Use the logged in user as the default.
             */
            getVariation: function (page, email) {
                var branches = getBranches(page),
                    branchIdx = this.getUserExperimentVariation(email, branches.length);

                return branches[branchIdx];
            },

            /*
             *  Based on the current content experiment information,
             *  the given page, and the given user, decide what our app
             *  should do next.
             *
             *  @param page          [STRING] [REQUIRED] The page we're experimenting on.
             *  @param eventCategory [STRING] [REQUIRED] The category we want to use for seeing this content experiment easier.
             *  @param callbacks     [OBJECT] [OPTIONAL] If the behavior isn't simply redirect to a different page,
             *                                           call the given callback. Have the hash of the callback match
             *                                           with the matching value of the hash in getBranches related to
             *                                           the given page.
             *
             *  @param email         [STRING] [OPTIONAL] The user we want to run the experiment on.
             *                                           Use the logged in user as the default.
             */
            setVariation: function (page, eventCategory, callbacks, email) {
                var chosenBranch = this.getVariation(page, email);

                this.trackEvent(eventCategory, chosenBranch);
                try {
                    // Track the route change in GA:
                    // _gaq.push(['_setAccount', 'UA-3705553-1'],['_trackPageview', eventCategory + '/' + chosenBranch]);
                    ga('send', 'pageview', eventCategory + '/' + chosenBranch);
                    // GA4
                    gtag('event', 'page_view', {
                        page_path: eventCategory + '/' + chosenBranch,
                     });

                } catch(e) {
                    // Just ignore it
                }


                // Cookie the variation we get and remove the cookie at the end of the wizard?

                if (chosenBranch && callbacks && callbacks[chosenBranch]) {
                    callbacks[chosenBranch]();
                } else if (chosenBranch) {
                    window.location = chosenBranch;
                } else {
                    throw new Error('Tracking variation not found.');
                }
            }
        };
    }];
});

